import React, { useEffect, useState } from "react";
import { useHistory } from 'react-router-dom';

import discover from 'assets/discover.png';
import podcast from 'assets/podcast.png';
import profile from 'assets/profile.png';
import podcastActive from 'assets/active-note.png';
import discoverActive from 'assets/active-discover.png';
import profileActive from 'assets/active-profile.png';
import Style from './navigation.module.css';

const tabs = [{
  route: '/podcast',
  label: 'Podcast',
  key: '1',
  icon: podcast,
  active: podcastActive,
  tooltip: 'Press 1 to open Podcast'
}, {
  route: '/trending',
  label: 'Trending',
  key: '2',
  icon: discover,
  active: discoverActive,
  tooltip: 'Press 2 to open Trending'
}, {
  route: '/settings',
  label: 'Settings',
  key: '3',
  icon: profile,
  active: profileActive,
  tooltip: 'Press 3 to open Settings'
}];

const Navigation = (props) => {
  const navigate = useHistory();
  const handleRoute = (route) => { navigate.push(route); };

  const getActiveColor = (label) => {
    return props.active === label ? '#451e53' : '#c4b5c9';
  };

  useEffect(() => {
    document.addEventListener('keydown', onKeyDown);
    return () => { document.removeEventListener('keydown', onKeyDown); };
  }, []);

  const onKeyDown = (e) => {
    // Ignore key shortcuts when typing in inputs/textareas/selects/contenteditable
    const target = e && e.target;
    const tag = target && target.tagName ? target.tagName.toLowerCase() : '';
    const isFormField = tag === 'input' || tag === 'textarea' || tag === 'select' || (target && target.isContentEditable);
    if (isFormField) {
      return;
    }
    if (e.key === '1') {
      if (props.active !== 'Podcast') {
        navigate.push('/podcast');
      }
    } else if (e.key && e.key === '2') {
      if (props.active !== 'Trending') {
        navigate.push('/trending');
      }
    } else if (e.key && e.key === '3') {
      if (props.active !== 'Settings') {
        navigate.push('/settings');
      }
    }
  };

  return (
    <>
      <nav className={Style.navContainer}>
        <div className={Style.navDiv}>
          {
            tabs.map((tab, index) => (
              <div className={Style.paddingEven} title={tab.tooltip} key={index} onClick={() => { handleRoute(tab.route); }} style={{ cursor: 'pointer' }}>
                <div className={Style.iconStyling}>
                  <div className={Style.iconWrapper}>
                    <svg strokeWidth='0' viewBox='0 0 24 24' height='28px' width='28px' xmlns='http://www.w3.org/2000/svg'>
                      {tab.label === 'Podcast' ? (
                        <path fill={getActiveColor(tab.label)} d='M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z' />
                      ) : tab.label === 'Trending' ? (
                        // Stock market up arrow (Material trending_up style)
                        <path fill={getActiveColor(tab.label)} d='M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 10V6z' />
                      ) : tab.label === 'Settings' ? (
                        // Sliders/tune icon for Settings (clear at small sizes)
                        <path fill={getActiveColor(tab.label)} d='M3 17h14v2H3v-2zm0-7h18v2H3V10zm0-7h10v2H3V3z' />
                      ) : (
                        <path fill={getActiveColor(tab.label)} d='M6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-3 .5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm15 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-11 10c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-17c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 5.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm8 .5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z' />
                      )}
                    </svg>
                  </div>
                  {/* <img src={props.active===tab.label?tab.active:tab.icon} style={{ height: '25px' }} alt='tab' /> */}
                  <div className={Style.iconLabel} style={{ color: getActiveColor(tab.label) }}>{tab.label} ({tab.key})</div>
                </div>
              </div>
            ))
          }
        </div>
      </nav>
    </>
  );
};

export default Navigation;
